const ONE_OF_BILLION = 1000000000;

const formatCurrencyByBillionUnit = (money: number) => {
	return (money / ONE_OF_BILLION).toFixed(2);
};

export default formatCurrencyByBillionUnit;
